import { Component } from "react";
import Navbar from "./Navbar";
import { withRouter } from "../hock/withRouter";
import Swal from "sweetalert2";

class Main extends Component {
  apiUrl = process.env.REACT_APP_API_URL;

  api = {
    auth: this.apiUrl + "/authentication",
  };

  state = {
    auth: false,
  };

  componentDidMount() {
    this.handle.authenticationCheck();
  }

  handle = {
    authenticationCheck: async () => {
      try {
        //API 호출 등을 통해 로그인 여부 확인
        const response = await fetch(this.api.auth, {
          method: "GET",
          credentials: "include", // 이 옵션을 추가
        });

        const data = await response.json();

        // 임시로 로그인 여부를 true로 설정
        const isLoggedIn = data.code === "200" ? true : false;

        if (isLoggedIn) {
          this.setState({
            auth: true,
          });
          this.props.navigate("/main", { replace: true });
        } else {
          this.props.navigate("/", { replace: true });
        }
      } catch (error) {
        Swal.fire({
          text: "서버 오류가 발생하였습니다.",
          icon: "error",
        }).then(() => {
          this.props.navigate("/");
        });
      }
    },
  };

  render() {
    return (
      <div>
        {this.state.auth ? (
          <div>
            <Navbar auth={this.state.auth} />
          </div>
        ) : (
          <></>
        )}
      </div>
    );
  }
}

export default withRouter(Main);
